export function formatCustomDate(datetimeStr) {
  // Get the 'lang' query parameter from the URL
  const searchParams = new URLSearchParams(window.location.search);
  const lang = searchParams.get("lang") || "en"; // default to 'en' if not set

  const date = new Date(datetimeStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return lang === "ar" ? `${year}/${month}/${day}` : `${day}/${month}/${year}`;
}
